<!-- =========================================================================================
	File Name: VxSidebarGroup.vue
	Description: Sidebar Group Component. Extends vuesax framework's 'vs-sidebar-group' component
	Component Name: VxSidebarGroup
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- && (group.url === $route.path || group.url === $store.state.nextPath) -->
  <div
    :class="[
      { 'vs-sidebar-group-open': openItems },
      { 'vs-sidebar-group-active': open },
      { 'disabled-item pointer-events-none': group.isDisabled },
      {
        'vs-sidebar-group-active-account':
          group.meta && group.meta.type === 'account-menu',
      },
      {
        'vs-sidebar-group-active-account-addaccount':
          group.meta &&
          group.meta.type === 'account-menu' &&
          group.slug === 'add-account',
      },
    ]"
    class="vs-sidebar-group"
    @mouseover="mouseover"
    @mouseout="mouseout"
  >
    <div @click="clickGroup" class="group-header w-full">
      <span class="flex items-center w-full">
        <feather-icon
          :icon="group.icon || 'CircleIcon'"
          :svgClasses="{ 'w-3 h-3': this.groupIndex % 1 != 0 }"
          v-if="group.icon || this.groupIndex > Math.floor(this.groupIndex)"
        />
        <span
          data-click="(group.meta && group.meta.type === 'account-menu' ? gotoGroupUrl(group.url) : null)"
          v-show="!sidebarItemsMin"
          class="truncate mr-3 select-none"
        >
          <img
            v-if="activeAccountSettlementType === 'bitcoin'"
            src="@/assets/images/logo/bitcoin.svg"
            class="account-type-icon"
          />
          <img
            v-else-if="
              activeAccountSettlementType === 'tripleabitcoin' ||
              activeAccountSettlementType === 'localcurrency'
            "
            src="@/assets/images/logo/wallet-icon.png"
            class="account-type-icon-dollar"
          />
          <img
            v-else
            src="@/assets/images/logo/plus-icon.svg"
            class="account-type-icon-plus"
          />
          {{ activeAccountName || group.name }}
        </span>
        <vs-chip
          class="ml-auto mr-4"
          :color="group.tagColor"
          v-if="group.tag && !sidebarItemsMin"
          >{{ group.tag }}</vs-chip
        >
      </span>
      <feather-icon
        icon="ChevronRightIcon"
        v-if="
          !(group.slug === 'add-account' && (group.submenu || []).length === 0)
        "
        svg-classes="w-4 h-4"
        :class="[{ rotate90: openItems }, 'feather-grp-header-arrow']"
        v-show="!sidebarItemsMin"
      />
      <span class="vs-sidebar--tooltip">{{ group.name }}</span>
    </div>
    <ul ref="items" :style="styleItems" class="vs-sidebar-group-items">
      <li v-for="(groupItem, index) in group.submenu" :key="index">
        <vx-sidebar-group
          :group="groupItem"
          :groupIndex="Number(`${groupIndex}.${index}`)"
          :open="isGroupActive(groupItem)"
          :openHover="openHover"
          v-if="groupItem.submenu"
        />
        <vx-sidebar-item
          v-else-if="!groupItem.card"
          :index="groupIndex + '.' + index"
          :to="groupItem.url"
          :icon="null"
          icon-small
          :item="groupItem"
          :target="groupItem.target"
        >
          <span class="truncate-white-space">
            <img
              v-if="groupItem.meta.settlementType === 'bitcoin'"
              src="@/assets/images/logo/bitcoin.svg"
              class="account-type-icon-small"
              alt="Bitcoin logo"
            />
            <img
              v-else-if="
                groupItem.meta.settlementType === 'tripleabitcoin' ||
                groupItem.meta.settlementType === 'localcurrency'
              "
              src="@/assets/images/logo/wallet-icon.png"
              class="account-type-icon-dollar-small"
              alt="Wallet logo"
            />
            <img
              v-else
              src="@/assets/images/logo/plus-icon.svg"
              class="account-type-icon-plus-small"
              alt="Plus logo"
            />
            {{ groupItem.name }}
          </span>
          <vs-chip
            class="ml-auto"
            :color="groupItem.tagColor"
            v-if="groupItem.tag"
            >{{ groupItem.tag }}</vs-chip
          >
        </vx-sidebar-item>
        <vx-sidebar-item-card
          v-else-if="groupItem.card"
          :index="groupIndex + '.' + index"
          :to="groupItem.url"
          :icon="itemIcon(groupIndex + '.' + index)"
          icon-small
          :item="groupItem"
          :target="groupItem.target"
        >
          <span class="truncate">{{ groupItem.name }}</span>
          <vs-chip
            class="ml-auto"
            :color="groupItem.tagColor"
            v-if="groupItem.tag"
            >{{ groupItem.tag }}</vs-chip
          >
        </vx-sidebar-item-card>
      </li>
    </ul>
  </div>
</template>

<script>
import VxSidebarItem from './VxSidebarItem.vue';
import VxSidebarItemCard from './VxSidebarItemCard.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'vx-sidebar-group',
  props: {
    openHover: {
      default: false,
      type: Boolean,
    },
    open: {
      default: false,
      type: Boolean,
    },
    group: {
      type: Object,
    },
    groupIndex: {
      type: Number,
    },
  },
  data: () => ({
    maxHeight: '0px',
    openItems: false,
  }),
  created() {
    console.log('Group in VxSidebarGroup', this.group);
  },
  computed: {
    ...mapGetters(['activeAccountGetter']),

    /*activeApiId()
      {
        console.debug('##### ###### ###### ###### ####### ###### activeApiId() computed value');
        let activeAccount = this.activeAccountGetter;
        if (activeAccount && activeAccount.apiId)
        {
          return activeAccount.apiId;
        }
        else
        {
          console.debug('activeApiId computed is not set');
          return '';
        }
      },*/
    activeAccountName() {
      let activeAccount = this.activeAccountGetter;
      if (activeAccount && activeAccount.name) {
        //console.log('account name is ', activeAccount.name);
        return activeAccount.name;
      } else {
        //console.warn('activeAccountName is AddWallet');
        return 'Add wallet';
      }
    },

    activeAccountSettlementType() {
      let activeAccount = this.activeAccountGetter;
      if (activeAccount && activeAccount.settlementType) {
        //console.log('account type is ', activeAccount.settlementType);
        return activeAccount.settlementType;
      } else {
        return '';
      }
    },
    sidebarItemsMin() {
      return this.$store.state.sidebarItemsMin;
    },
    styleItems() {
      return {
        maxHeight: this.maxHeight,
      };
    },
    itemIcon() {
      return (index) => {
        if (!((index.match(/\./g) || []).length > 1)) return 'CircleIcon';
      };
    },
    isGroupActive() {
      return (sidebarItem) => {
        const path = this.$route.fullPath;
        let open = false;
        let func = function (sidebarItem) {
          if (sidebarItem.submenu) {
            sidebarItem.submenu.forEach((item) => {
              if (path == item.url) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };

        func(sidebarItem);
        return open;
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    //console.log('beforeRouteLeave', to);
    //window.confirm('Do you really want to leave? you have unsaved changes!');
    next();
  },
  watch: {
    activeAccountName(newValue, oldValue) {
      //console.debug('sidebar group : =================================== watch detected name change for active wallet !', newValue, oldValue);
    },
    activeAccountGetter(newValue, oldValue) {
      //console.debug('sidebar group : =================================== watch detected activeAcount update !', newValue, oldValue);

      if (this.group.meta && this.group.meta.type === 'account-menu') {
        //console.debug('GROUP CLOSING !', this.group);
        this.maxHeight = `0px`;
      }

      if (this.sidebarItemsMin) return;
      let scrollHeight = this.scrollHeight;
      if (this.openItems && !this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = `${0}px`;
        }, 50);
      } else if (this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = 'none';
        }, 300);
      }
    },
    // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
    $route() {
      //console.log('sidebar Group item detects route change', this.$route);

      if (this.group.meta && this.group.meta.type === 'account-menu') {
        //console.debug('GROUP CLOSING !');
        this.maxHeight = `0px`;
      }

      if (this.sidebarItemsMin) return;
      let scrollHeight = this.scrollHeight;
      if (this.openItems && !this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = `${0}px`;
        }, 50);
      } else if (this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = 'none';
        }, 300);
      }
    },
    maxHeight() {
      this.openItems = this.maxHeight != '0px';
    },
    // OPEN AND CLOSES DROPDOWN MENU ON SIDEBAR COLLAPSE AND DEFAULT VIEW
    '$store.state.sidebarItemsMin'(val) {
      let scrollHeight = this.$refs.items.scrollHeight;
      if (!val && this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = 'none';
        }, 300);
      } else {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = '0px';
        }, 50);
      }
      if (val && this.open) {
        this.maxHeight = `${scrollHeight}px`;
        setTimeout(() => {
          this.maxHeight = '0px';
        }, 250);
      }
    },
  },
  methods: {
    gotoGroupUrl(groupUrl) {
      //console.warn('gotoGroupUrl called for ' + groupUrl);
      if (this.group && this.group.meta && this.group.meta.apiId) {
        //console.debug('DEBUG: RouterLink clicked. Setting active account to ' + this.group.meta.apiId);
        this.$store.commit('SET_ACTIVE_ACCOUNT', this.group.meta.apiId);
      } else if (this.group && (!this.group.meta || !this.group.meta.apiId)) {
        //console.debug('DEBUG: RouterLink clicked. (AddWallet) Setting active account to ' + 'EMPTY');
        this.$store.commit('SET_ACTIVE_ACCOUNT', null);
      }

      this.$router.push(groupUrl);
    },
    clickGroup() {
      if (!this.openHover) {
        console.log('ScrollHeight', this.$refs.items.scrollHeight);
        let thisScrollHeight = this.$refs.items.scrollHeight;
        if (this.maxHeight == '0px') {
          this.maxHeight = `${thisScrollHeight}px`;
          setTimeout(() => {
            this.maxHeight = 'none';
          }, 300);
        } else {
          this.maxHeight = `${thisScrollHeight}px`;
          setTimeout(() => {
            this.maxHeight = `${0}px`;
          }, 50);
        }

        this.$parent.$children.map((child) => {
          if (child.isGroupActive) {
            if (child !== this && !child.open && child.maxHeight != '0px') {
              setTimeout(() => {
                child.maxHeight = `${0}px`;
              }, 50);
            }
          }
        });
      }
    },
    mouseover() {
      if (this.openHover) {
        let scrollHeight = this.$refs.items.scrollHeight;
        this.maxHeight = `${scrollHeight}px`;
      }
    },
    mouseout() {
      if (this.openHover) {
        let scrollHeight = 0;
        this.maxHeight = `${scrollHeight}px`;
      }
    },
  },
  components: {
    VxSidebarItem,
    VxSidebarItemCard,
  },
  mounted() {
    this.openItems = this.open;
    if (this.open) {
      this.maxHeight = 'none';
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/vuesax/components/vxSidebarGroup.scss';
</style>

<style>
.account-type-icon {
  width: 20px;
  transform: translateY(4px);
  filter: grayscale(0.15);
}
.account-type-icon-dollar {
  width: 15px;
  transform: translateY(2px);
  filter: grayscale(0.15);
}
.account-type-icon-plus {
  width: 15px;
  margin-right: 3px;
  transform: translateY(2px);
  filter: invert(0.4);
}

.account-type-icon-small {
  width: 20px;
  margin-right: 2px;
  transform: translateY(4px);
  filter: grayscale(0.3);
}
.account-type-icon-dollar-small {
  width: 14px;
  margin-right: 6px;
  transform: translateY(1px);
  filter: grayscale(0.3);
}
.account-type-icon-plus-small {
  width: 14px;
  margin-right: 6px;
  transform: translateY(1px);
  /*filter: invert(1) grayscale(0.3);*/
  opacity: 0.4;
}
</style>
